import loginApi from './login-api'
import monthLiveApi from './monthLive-api'
import memberListApi from './memberList-api'
import checkRoomApi from './checkRoom-api'
import babyLiveApi from './babyLive-api'
import bbFormApi from './bbForm-api'
import otherFormApi from './otherForm-api'
import chritmasFormApi from './chritmasForm-api'

export default{
  loginApi,
  monthLiveApi,
  memberListApi,
  checkRoomApi,
  babyLiveApi,
  bbFormApi,
  otherFormApi,
  chritmasFormApi
}



// WEBPACK FOOTER //
// ./src/service/api/repository/index.js